import React, { useState, useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MessengerLayout        from "../../layout/MessengerLayout";
import TicketSummary          from "../../components/tickets/TicketSummary";
import TicketSubmissionForm   from "../../components/tickets/TicketSubmissionForm";
import TicketList             from "../../components/tickets/TicketList";
import TicketThread           from "../../components/tickets/TicketThread";
import TicketActions          from "../../components/tickets/TicketActions";

export default function TicketsMessengerPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const submitRef = useRef(null);
  const [activeId,   setActiveId]   = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = useCallback(() => setRefreshKey(k => k + 1), []);

  useEffect(() => {
    const handleKiraAction = (e) => {
      const t = e.detail?.action_type || "";
      if (["ticket_raise"].includes(t)) {
        bump();
      }
    };
    window.addEventListener("kira_action_complete", handleKiraAction);
    return () => window.removeEventListener("kira_action_complete", handleKiraAction);
  }, [bump]);

  // Auto-scroll to the submission form when dashboard quick-action links
  // here with ?new=true. Strip the param after so a refresh doesn't keep
  // firing the scroll.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("new") === "true") {
      setTimeout(() => {
        submitRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        const firstInput = submitRef.current?.querySelector(
          "input,select,textarea"
        );
        firstInput?.focus?.();
      }, 50);
      params.delete("new");
      const qs = params.toString();
      navigate(`${location.pathname}${qs ? `?${qs}` : ""}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return (
    <MessengerLayout>
      <div className="p-6 space-y-5 text-white">

        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-[#00ff90]">Tickets</h1>
            <p className="text-white/40 text-sm mt-0.5">Submit issues, track progress and reply in-thread</p>
          </div>
        </div>

        {/* Summary + Submit */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <TicketSummary refreshKey={refreshKey} />
          <div ref={submitRef}>
            <TicketSubmissionForm onSubmitSuccess={bump} />
          </div>
        </div>

        {/* List + Thread + Actions */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <TicketList
            key={`list-${refreshKey}`}
            onSelect={setActiveId}
            activeId={activeId}
            refreshKey={refreshKey}
          />
          <div className="space-y-4">
            <TicketThread ticketId={activeId} onReplySuccess={bump} />
            <TicketActions ticketId={activeId} refresh={bump} />
          </div>
        </div>

      </div>
    </MessengerLayout>
  );
}